import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSevereIssue = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.45751 15.6833C4.86661 15.6833 4.3777 15.2214 4.34471 14.6305L4.17974 11.6926C2.97695 10.6023 2.28857 9.06203 2.28857 7.46182C2.28857 4.27489 4.9491 1.68335 8.21852 1.68335C11.4879 1.68335 14.1485 4.27489 14.1485 7.46182C14.1485 9.06053 13.4601 10.6008 12.2588 11.6911L12.0953 14.629C12.0623 15.2199 11.5734 15.6818 10.9825 15.6818H5.45751V15.6833ZM10.9405 14.5241L11.116 11.3446V11.1317L11.134 11.1182C12.3128 10.2348 12.9892 8.90156 12.9892 7.46182C12.9892 4.91527 10.849 2.84264 8.21852 2.84264C5.58799 2.84264 3.44787 4.91527 3.44787 7.46182C3.44787 8.90156 4.12425 10.2348 5.30304 11.1182L5.32103 11.1317V11.3401L5.4995 14.5241H6.56731V12.9643C6.56731 12.6449 6.82676 12.3839 7.14771 12.3839C7.46865 12.3839 7.7281 12.6434 7.7281 12.9643V14.5241H8.70893V12.9643C8.70893 12.6449 8.96838 12.3839 9.28932 12.3839C9.61027 12.3839 9.86972 12.6434 9.86972 12.9643V14.5241H10.9405ZM10.2387 8.06471C9.69425 8.06471 9.25183 7.62229 9.25183 7.07939C9.25183 6.53648 9.69425 6.09256 10.2387 6.09256C10.7831 6.09256 11.2255 6.53498 11.2255 7.07939C11.2255 7.62379 10.7831 8.06471 10.2387 8.06471ZM6.10089 8.06471C5.55649 8.06471 5.11407 7.62229 5.11407 7.07939C5.11407 6.53648 5.55649 6.09256 6.10089 6.09256C6.6453 6.09256 7.08772 6.53498 7.08772 7.07939C7.08772 7.62379 6.6453 8.06471 6.10089 8.06471Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgSevereIssue);
export { ForwardRef as ReactComponent };
